export function findFocusedActivityElement({ activityId, dateKey }, root = document) {
  if (!activityId || !root?.getElementById) return null;

  const baseId = `activity-${activityId}`;
  const ordinaryRow = root.getElementById(baseId);
  if (ordinaryRow) return ordinaryRow;

  if (dateKey) {
    const completionDayPart = root.getElementById(`${baseId}_part_${dateKey}`);
    if (completionDayPart) return completionDayPart;
  }

  // A multi-day workout has no ordinary row. Its virtual parts are rendered in
  // date order, so the last part is the completion-day fallback.
  const parts = Array.from(root.querySelectorAll?.(`[id^="${baseId}_part_"]`) || []);
  return parts[parts.length - 1] || null;
}
